var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "split-root" },
    [
      _c(
        "div",
        {
          ref: "listEl",
          staticClass: "split-list",
          on: {
            "&scroll": function ($event) {
              return _vm.onScroll()
            },
          },
        },
        [
          _c("div", { staticClass: "split-list-head" }, [
            _vm._v(_vm._s(_vm.$ct("x-documents", { count: _vm.rows.length }))),
          ]),
          _vm._l(_vm.rows, function (row) {
            return _c(
              "a",
              {
                key: row.key,
                staticClass: "split-row",
                class: { active: _vm.activeKey == row.key },
                on: {
                  click: function ($event) {
                    return _vm.openRow(row)
                  },
                },
              },
              [
                _c(
                  "span",
                  { staticClass: "source-badge", class: _vm.source(row) },
                  [_c("w-fa", { attrs: { icon: _vm.sourceIcon(row) } })],
                  1
                ),
                _c("span", { staticClass: "split-row-body" }, [
                  _c("span", { staticClass: "split-row-line" }, [
                    _c("span", { staticClass: "row-supplier" }, [
                      _vm._v(_vm._s(_vm.supplier(row))),
                    ]),
                    _c("span", { staticClass: "row-amount" }, [
                      _vm._v(_vm._s(_vm.amount(row) || _vm.dash)),
                    ]),
                  ]),
                  _c("span", { staticClass: "split-row-line secondary" }, [
                    _c("span", { staticClass: "row-reference" }, [
                      _vm._v(_vm._s(_vm.reference(row))),
                    ]),
                    _c("span", [_vm._v(_vm._s(_vm.dateInfo(row)))]),
                  ]),
                  _vm.isApproved(row) || row.file.Labels.length
                    ? _c(
                        "span",
                        { staticClass: "split-row-line chips" },
                        [
                          _vm.isApproved(row)
                            ? _c(
                                "span",
                                { staticClass: "status-chip approved" },
                                [
                                  _c("span", { staticClass: "status-dot" }),
                                  _vm._v(_vm._s(_vm.$ct("approved")) + " "),
                                ]
                              )
                            : _vm._e(),
                          _vm._l(row.file.Labels, function (label) {
                            return _c(
                              "span",
                              {
                                key: label.ID,
                                staticClass: "label-chip",
                                style: {
                                  backgroundColor: label.Color,
                                  color: _vm.textColor(label.Color),
                                },
                              },
                              [_vm._v(_vm._s(label.Name))]
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ]),
              ]
            )
          }),
          !_vm.rows.length
            ? _c("div", { staticClass: "split-empty" }, [
                _vm._v(_vm._s(_vm.$ct("all-processed"))),
              ])
            : _vm._e(),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "split-detail" },
        [
          _vm.activeRow
            ? [
                _c(
                  "div",
                  { staticClass: "detail-head" },
                  [
                    _c("div", { staticClass: "detail-title" }, [
                      _c("div", { staticClass: "detail-supplier" }, [
                        _vm._v(_vm._s(_vm.supplier(_vm.activeRow))),
                      ]),
                      _c(
                        "div",
                        { staticClass: "detail-subtitle" },
                        [
                          _vm.invoiceNumber(_vm.activeRow)
                            ? [
                                _vm._v(
                                  _vm._s(
                                    _vm.$ct("invoice-nr", {
                                      nr: _vm.invoiceNumber(_vm.activeRow),
                                    })
                                  ) + " · "
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(
                            " " + _vm._s(_vm.receivedVia(_vm.activeRow)) + " "
                          ),
                          _c("app-timeago", {
                            attrs: {
                              datetime: _vm.activeRow.purchase.DateCreated,
                            },
                          }),
                        ],
                        2
                      ),
                    ]),
                    _c("w-spacer"),
                    _c(
                      "w-button",
                      {
                        staticClass: "cancel mls",
                        on: {
                          click: function ($event) {
                            return _vm.download(_vm.activeRow)
                          },
                        },
                      },
                      [
                        _c("w-fa", {
                          staticClass: "mrs",
                          attrs: { icon: "download" },
                        }),
                        _vm._v(_vm._s(_vm.$ct("download-short")) + " "),
                      ],
                      1
                    ),
                    _c("w-dropdown", {
                      staticClass: "mls",
                      attrs: {
                        right: "",
                        "trigger-class": "cancel",
                        icon: "ellipsis-h",
                        items: _vm.menuItems(_vm.activeRow),
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onMenuClick(_vm.activeRow, $event)
                        },
                      },
                    }),
                    _c(
                      "w-button",
                      {
                        staticClass: "mls",
                        attrs: { disabled: _vm.creating },
                        on: {
                          click: function ($event) {
                            return _vm.create(_vm.activeRow)
                          },
                        },
                      },
                      [
                        _c("w-fa", {
                          staticClass: "mrs",
                          attrs: { icon: "cart-plus" },
                        }),
                        _vm._v(_vm._s(_vm.$ct("create-purchase")) + " "),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "detail-body" }, [
                  _c(
                    "div",
                    { staticClass: "detail-preview" },
                    [
                      _vm.previewBlob
                        ? _c("app-pdf-viewer", {
                            attrs: { blob: _vm.previewBlob },
                          })
                        : _vm.previewImageUrl
                        ? _c("img", {
                            attrs: {
                              src: _vm.previewImageUrl,
                              alt: _vm.reference(_vm.activeRow),
                            },
                          })
                        : _vm.previewError
                        ? _c("div", { staticClass: "preview-message" }, [
                            _vm._v(_vm._s(_vm.previewError)),
                          ])
                        : _c("app-delayed-progress"),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "detail-side" }, [
                    _c("div", { staticClass: "side-label" }, [
                      _vm._v(_vm._s(_vm.$ct("total-incl-vat"))),
                    ]),
                    _c("div", { staticClass: "side-total" }, [
                      _vm._v(_vm._s(_vm.amount(_vm.activeRow) || _vm.dash)),
                    ]),
                    _vm.amountExcl(_vm.activeRow)
                      ? _c(
                          "div",
                          { staticClass: "side-sub" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$ct("excl-vat")) +
                                " " +
                                _vm._s(_vm.amountExcl(_vm.activeRow))
                            ),
                            _vm.vatPercentage(_vm.activeRow)
                              ? [
                                  _vm._v(
                                    " · " +
                                      _vm._s(_vm.$ct("vat")) +
                                      " " +
                                      _vm._s(_vm.vatPercentage(_vm.activeRow))
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm.isApproved(_vm.activeRow)
                      ? _c("div", { staticClass: "side-status" }, [
                          _c("span", { staticClass: "status-chip approved" }, [
                            _c("span", { staticClass: "status-dot" }),
                            _vm._v(_vm._s(_vm.$ct("approved"))),
                          ]),
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "side-rows" }, [
                      _c("div", { staticClass: "side-row" }, [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$ct("col-invoice-date"))),
                        ]),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.printDate(_vm.invoiceDate(_vm.activeRow))
                            )
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "side-row" }, [
                        _c("span", [_vm._v(_vm._s(_vm.$ct("col-due-date")))]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.dueDateWithDays(_vm.activeRow))),
                        ]),
                      ]),
                      _c("div", { staticClass: "side-row" }, [
                        _c("span", [_vm._v(_vm._s(_vm.$ct("vat-number")))]),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.vatNumber(_vm.activeRow) || _vm.dash)
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "side-row" }, [
                        _c("span", [_vm._v(_vm._s(_vm.$ct("file")))]),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.reference(_vm.activeRow),
                                expression: "reference(activeRow)",
                              },
                            ],
                            staticClass: "side-file",
                          },
                          [_vm._v(_vm._s(_vm.reference(_vm.activeRow)))]
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "side-label" }, [
                      _vm._v(_vm._s(_vm.$ct("col-labels"))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "side-labels" },
                      [
                        _vm._l(_vm.activeRow.file.Labels, function (label) {
                          return _c(
                            "span",
                            {
                              key: label.ID,
                              staticClass: "label-chip",
                              style: {
                                backgroundColor: label.Color,
                                color: _vm.textColor(label.Color),
                              },
                            },
                            [_vm._v(_vm._s(label.Name))]
                          )
                        }),
                        _c(
                          "a",
                          {
                            staticClass: "add-label",
                            on: {
                              click: function ($event) {
                                _vm.labelsOpen = true
                              },
                            },
                          },
                          [
                            _c("w-fa", {
                              staticClass: "mrs",
                              attrs: { icon: "tag" },
                            }),
                            _vm._v(_vm._s(_vm.$ct("label"))),
                          ],
                          1
                        ),
                      ],
                      2
                    ),
                  ]),
                ]),
              ]
            : _c("div", { staticClass: "preview-message" }, [
                _vm._v(_vm._s(_vm.$ct("select-a-document"))),
              ]),
        ],
        2
      ),
      _vm.noteOpen && _vm.activeRow
        ? _c("app-set-note-for-bookkeeper-modal", {
            attrs: { purchase: _vm.activeRow.purchase },
            on: {
              close: function ($event) {
                _vm.noteOpen = false
              },
            },
          })
        : _vm._e(),
      _vm.labelsOpen && _vm.activeRow
        ? _c("app-assign-labels-modal", {
            attrs: { file: _vm.activeRow.file, labels: _vm.state.labels },
            on: {
              close: function ($event) {
                _vm.labelsOpen = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }